/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1SettingsCosttypesQueryResponse } from '../../types/GetV1SettingsCosttypes.ts'

export const getV1SettingsCosttypesQueryKey = () => [{ url: '/v1/settings/costtypes' }] as const

export type GetV1SettingsCosttypesQueryKey = ReturnType<typeof getV1SettingsCosttypesQueryKey>

/**
 * {@link /v1/settings/costtypes}
 */
export async function getV1SettingsCosttypes(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1SettingsCosttypesQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/settings/costtypes`, ...requestConfig })
    return res
}

export function getV1SettingsCosttypesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1SettingsCosttypesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1SettingsCosttypesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1SettingsCosttypesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1SettingsCosttypes(config)
        },
    })
}

/**
 * {@link /v1/settings/costtypes}
 */
export function useGetV1SettingsCosttypes<
    TData = ResponseConfig<GetV1SettingsCosttypesQueryResponse>,
    TQueryData = ResponseConfig<GetV1SettingsCosttypesQueryResponse>,
    TQueryKey extends QueryKey = GetV1SettingsCosttypesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1SettingsCosttypesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1SettingsCosttypesQueryKey()

    const query = useQuery(
        {
            ...getV1SettingsCosttypesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
